"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSuccessResponse = void 0;
var tslib_1 = require("tslib");
var object_1 = require("@wix/wix-vod-shared/dist/src/common/utils/object");
var parseSuccessResponse = function (_a) {
    var data = _a.data;
    var camelCasedData = (0, object_1.keysToCamelCase)(data);
    var createdTs = camelCasedData.createdTs, updatedTs = camelCasedData.updatedTs;
    var createdTsDate = new Date(Number(createdTs) * 1000);
    var updatedTsDate = new Date(Number(updatedTs) * 1000);
    return (0, tslib_1.__assign)((0, tslib_1.__assign)({}, camelCasedData), { createdTs: createdTsDate, updatedTs: updatedTsDate });
};
exports.parseSuccessResponse = parseSuccessResponse;
//# sourceMappingURL=success-response.js.map